import { render, staticRenderFns } from "./AliPay.vue?vue&type=template&id=3d0db85c&scoped=true"
import script from "./AliPay.vue?vue&type=script&lang=js"
export * from "./AliPay.vue?vue&type=script&lang=js"
import style0 from "./AliPay.vue?vue&type=style&index=0&id=3d0db85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0db85c",
  null
  
)

export default component.exports